export default __webpack_public_path__ + "static/assets/bbea375f6378de561164ac03e75c69ef.png";